import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { getIncortermListEffect } from '../../../redux/shipment/ShipmentEffects';
import FormSelectBox from '../Inputs/FormSelectBox';

const HalIncotermSelector = ({
  placeholder = i18n.t('translation:default.fields.appointmentType.placeholder'),
  label = i18n.t('translation:default.fields.appointmentType.label'),
  rules = [],
  name,
  editMode,
  margin,
  tooltip = false,
  isDefault = false,
  onChange,
  dataTestId,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getStatusList();
  }, []);

  const getStatusList = async () => {
    try {
      setLoading(true);
      const { data } = await getIncortermListEffect();
      const options = data.map((row) => ({
        label: row.codeId,
        value: row.codeId,
      }));
      setOptions(options);
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={isDefault === true ? [{ label: 'Select', value: '' }, ...options] : options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      tooltip={tooltip}
      onChange={onChange}
      dataTestId={dataTestId}
    />
  );
};

export default HalIncotermSelector;
